import { PlanningTaskStatus } from '@app/shared/models/planning-task-status';
import { PxdAgDatePickerEditorComponent } from '@app/shared/aggrid/pxd-ag-grid-datepicker-editor';
import { PxdAgEditGridDefaultColumnDef, PxdAgGridColumnTypes, PxdAgGridExcelStyles, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions, PXDDefaultExcelExportParams } from "@app/shared/aggrid/pxd-ag-grid-options";
import { PxdAgGridSelectEditorComponent } from '@app/shared/aggrid/pxd-ag-grid-select-editor';
import { Injectable } from '@angular/core';

export class PlanningTasksGridOptions implements PxdAgGridOptions {
  enableCharts = true;
  cellSelection = true;
  rowGroupPanelShow: 'always' | 'onlyWhenGrouping' | 'never' = 'always';
  defaultColDef = PxdAgEditGridDefaultColumnDef;
  statusBar = PxdAgGridStatusBarOptions;
  sideBar = PxdAgGridSideBarOptions;
  columnTypes = PxdAgGridColumnTypes;
  excelStyles = PxdAgGridExcelStyles;
  defaultExcelExportParams = PXDDefaultExcelExportParams;
  columnDefs = [];
}

@Injectable({
  providedIn: 'root'
})
export class PlanningTasksGridOptionsService {
  public planningTasksGridOptions: PlanningTasksGridOptions = new PlanningTasksGridOptions();

  public constructor() {
    this.planningTasksGridOptions.columnDefs = this.columnDefs;
  }
  PlanningTaskStatus: Map<number, PlanningTaskStatus> = new Map();

  getPlanningStatus = (id) => {
    if (!id) return '';
    let pStatus = this.PlanningTaskStatus.get(id);
    if (pStatus) return pStatus.Description;
    return '';
  }

  columnDefs = [
    { field: 'PlanningTaskType', rowGroup: true, hide: true },
    { field: 'Description', headerName: 'Task', editable: false },
    { field: 'TargetCompletionDate', headerName: 'Target Complete Date', type: ['dateColumn'], editable: false, tooltipField: 'EquationValue', cellClass: 'ExcelDate' },
    {
      field: 'PlanningStatusId', headerName: 'Status',
      cellRenderer: params => {
        return this.getPlanningStatus(params.value);
      },
      cellEditorSelector: params => {
        return {
          component: PxdAgGridSelectEditorComponent,
          params: {
            values: Array.from(this.PlanningTaskStatus.values()).map(d => {
              return { value: d.PlanningTaskStatusId, text: d.Description };
            })
          }
        };
      }
    },
    {
      field: 'ActualStartDate', headerName: 'Start Date', type: ['dateColumn'], cellClass: 'ExcelDate',
      cellEditorSelector: params => {
        return { component: PxdAgDatePickerEditorComponent };
      },
      filter: 'agDateColumnFilter',
      filterParams: {
        includeBlanksInEquals: false,
        includeBlanksInGreaterThan: false,
        includeBlanksInLessThan: false
      }
    },
    {
      field: 'ActualCompleteDate', headerName: 'End Date', cellClass: 'ExcelDate',
      type: ['dateColumn'],
      cellEditorSelector: params => {
        return { component: PxdAgDatePickerEditorComponent };
      },
      filter: 'agDateColumnFilter',
      filterParams: {
        includeBlanksInEquals: false,
        includeBlanksInGreaterThan: false,
        includeBlanksInLessThan: false
      }
    },
    { field: 'Comments' },
  ];
}